<div class="info-modal__title">
  <app-game-icon game="Tower"></app-game-icon>
  <h2>Tower</h2>
</div>
<div class="info-modal__body">
  <p>
    The classic game of Blackjack, play it the way it was meant to be played.
    The player closest to 21 wins, and going above results in an instant loss.
  </p>
  <ul>
    <li>
      All games are played using Provably Fair, you can verify after the bet
      that your outcome was not altered or tampered with.
    </li>
    <li>
      Drawing a natural blackjack pays 3 to 2, and winning an insurance
      purchase pays 2 to 1.
    </li>
    <li>
      Splitting on a double ace will automatically hit once and then end your
      turn, you will not be able to hit again.
    </li>
    <li>
      We combine 8 decks of cards when dealing Blackjack, so it's possible for
      the same card to repeat.
    </li>
  </ul>
</div>
<app-info-modal-max-payout [maxPayout]="MAX_PAYOUT"></app-info-modal-max-payout>
